import React, { useContext } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import ReactSelect from 'react-select'
import Creatable from 'react-select/creatable'

import * as styles from '@/components/form/form.module.scss'
import FormContext from '@/components/form/form-context'

type Props = {
  id: string
  label: string
  options: {
    value: string | null | undefined
    label: string | null | undefined
  }[]
  required?: boolean
  create?: boolean
  align?: 'leftLabel' | 'centerLabel' | 'item'
}
const Select: React.FC<Props> = ({
  id,
  label,
  options,
  required,
  create = false,
  align = 'item'
}) => {
  const Select = create ? Creatable : ReactSelect
  const { control } = useFormContext()
  const formContext = useContext(FormContext)

  return (
    <div className={styles[align]}>
      <label htmlFor={id}>
        {label}
        {required === true ? '*' : ''}
      </label>
      <Controller
        name={id}
        control={control}
        render={({ field, fieldState }) => {
          const { onBlur } = field
          return (
            <div data-testid={id}>
              {/** Set onChange and value props to send the value as string with the value only.
               * react-select sends by default an object like {label: optionLabel, value: optionValue}
               */}
              <Select
                isClearable
                {...field}
                aria-label={id}
                options={options}
                getOptionValue={(option) => option.value ?? ''}
                onChange={(item) => {
                  field.onChange(item ? item.value : '')
                }}
                value={options.find((item) => item.value === field.value)}
                onBlur={onBlur}
                {...(formContext?.classes?.select && {
                  classNames: formContext?.classes?.select
                })}
              />
              {fieldState.error && <span>Please, select a {label}</span>}
            </div>
          )
        }}
      />
    </div>
  )
}
export default Select
